import { render, staticRenderFns } from "./PieChartComponent.vue?vue&type=template&id=0bb9dbb8&scoped=true&"
import script from "./PieChartComponent.vue?vue&type=script&lang=js&"
export * from "./PieChartComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb9dbb8",
  null
  
)

export default component.exports